import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, ClipboardCheckIcon, ChartBarIcon, HistoryIcon } from 'lucide-react';
const Header: React.FC = () => {
  const location = useLocation();
  const navItems = [{
    path: '/',
    icon: <HomeIcon size={20} data-id="element-16" />,
    text: 'Início'
  }, {
    path: '/evaluation',
    icon: <ClipboardCheckIcon size={20} data-id="element-17" />,
    text: 'Avaliação'
  }, {
    path: '/results',
    icon: <ChartBarIcon size={20} data-id="element-18" />,
    text: 'Resultados'
  }, {
    path: '/history',
    icon: <HistoryIcon size={20} data-id="element-19" />,
    text: 'Histórico'
  }];
  return <header className="bg-gray-800 text-white shadow-md" data-id="element-20">
      <div className="container mx-auto px-4 py-3" data-id="element-21">
        <div className="flex justify-between items-center" data-id="element-22">
          <Link to="/" className="flex items-center space-x-2" data-id="element-23">
            <span className="text-orange-400 font-bold text-xl" data-id="element-24">
              Avaliador de Pão Tipo Francês
            </span>
          </Link>
          <nav className="hidden md:flex space-x-6" data-id="element-25">
            {navItems.map(item => <Link key={item.path} to={item.path} className={`flex items-center space-x-1 py-2 border-b-2 ${location.pathname === item.path ? 'border-orange-400 text-orange-400' : 'border-transparent hover:border-orange-300 hover:text-orange-300'}`} data-id="element-26">
                {item.icon}
                <span data-id="element-27">{item.text}</span>
              </Link>)}
          </nav>
          <div className="md:hidden" data-id="element-28">
            {/* Mobile menu button would go here */}
          </div>
        </div>
      </div>
      {/* Mobile navigation */}
      <div className="md:hidden bg-gray-700" data-id="element-29">
        <div className="container mx-auto px-4 py-2 flex justify-between" data-id="element-30">
          {navItems.map(item => <Link key={item.path} to={item.path} className={`flex flex-col items-center py-1 px-2 ${location.pathname === item.path ? 'text-orange-400' : 'text-gray-300 hover:text-orange-300'}`} data-id="element-31">
              {item.icon}
              <span className="text-xs mt-1" data-id="element-32">{item.text}</span>
            </Link>)}
        </div>
      </div>
    </header>;
};
export default Header;